module.exports = __webpack_public_path__ + "img/ring2.1aacd107.png";